import {ADD_USERS, CHANGE_STATUS_USERS, DELETE_USERS, EDIT_USERS, GET_USERS} from "./users.types";

export const getUsers = (params, noLoad = false) => {
  return {
    type: GET_USERS,
    payload: {
      params,
      noLoad
    },
  };
};

export const addUser = (body) => {
  return {
    type: ADD_USERS,
    payload: {
      body,
    },
  };
};

export const editUser = (id, body) => {
  return {
    type: EDIT_USERS,
    payload: {
      id,
      body,
    },
  };
};

export const deleteUser = (id) => {
  return {
    type: DELETE_USERS,
    payload: {
      id,
    },
  };
};

export const changeStatus = (id, body) => {
  return {
    type: CHANGE_STATUS_USERS,
    payload: {
      id,
      body,
    },
  };
};